import { ReactNode } from 'react';

import clsx from 'clsx';
import styled from 'styled-components';

interface ArrivedGradientTopNavLogoProps {
  className?: string;
  isOnlyLogo?: boolean;
  children?: ReactNode;
}

const StyledNavArrivedLogo = styled.div<{ isOnlyLogo?: boolean }>`
  &.arrived-gradient-top-nav-logo-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${(props) => props.theme.spacing(2, 0)};
    width: ${({ isOnlyLogo }) => (isOnlyLogo ? '36px' : '154px')};

    svg {
      width: auto;
      height: ${({ isOnlyLogo }) => (isOnlyLogo ? '36px' : '32px')};
    }
  }
`;

export const NavArrivedLogo = ({ children, className, isOnlyLogo }: ArrivedGradientTopNavLogoProps) => {
  return (
    <StyledNavArrivedLogo isOnlyLogo={isOnlyLogo} className={clsx('arrived-gradient-top-nav-logo-wrapper', className)}>
      {children}
    </StyledNavArrivedLogo>
  );
};
